/**
 * dtf-upload-form.js
 * Handles all behaviour for snippets/dtf-upload-form.liquid
 *
 * FILE UPLOAD NOTE:
 *   Set window.DTF_CONFIG.uploadEndpoint to your upload URL.
 *   The endpoint should accept a multipart POST with field "file"
 *   and return JSON: { url: "https://..." }
 *   Until configured, only the filename is stored as the property.
 */

(function () {
  'use strict';

  // ─── Config ────────────────────────────────────────────────────────────────
  const CFG = window.DTF_CONFIG || {};
  const CURRENCY        = CFG.currency   || 'USD';
  const SUPABASE_URL    = CFG.supabaseUrl || '';
  const SUPABASE_KEY    = CFG.supabaseKey || '';
  const SUPABASE_BUCKET = 'File Uploads';
  const VARIANT_MAP     = CFG.variantMap  || [];
  const PRICE_MAP       = CFG.priceMap    || [];
  if (CFG.productUrl) { try { localStorage.setItem('dtfProductUrl', CFG.productUrl); } catch(e) {} }

  // ─── Helpers ───────────────────────────────────────────────────────────────
  function $(id) { return document.getElementById(id); }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: CURRENCY,
      minimumFractionDigits: 2
    }).format(amount);
  }

  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true;  }

  function setError(id, msg) {
    const el = $(id);
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  function clearErrors() {
    document.querySelectorAll('.dtf-error').forEach(function (el) {
      el.textContent = '';
      el.hidden = true;
    });
  }

  // ─── Dynamic list helpers (extra sizes / extra colors) ─────────────────────

  // Color rows — letters and single spaces only
  function makeDynamicRow(listId, placeholder, removeCb, addBtnId) {
    const list = $(listId);
    if (!list) return;
    if (list.querySelectorAll('.dtf-dynamic-row').length >= MAX_EXTRA) return;
    const row = document.createElement('div');
    row.className = 'dtf-dynamic-row';
    row.innerHTML =
      '<input type="text" class="dtf-input" placeholder="' + placeholder + '" autocomplete="off">' +
      '<button type="button" class="dtf-remove-row" aria-label="Remove">&#10005;</button>';
    row.querySelector('.dtf-remove-row').addEventListener('click', function () {
      row.remove();
      if (addBtnId) updateAddBtn(listId, addBtnId);
      if (removeCb) removeCb();
    });
    row.querySelector('input').addEventListener('input', function () {
      var clean = this.value.replace(/[^a-zA-Z ]/g, '').replace(/ {2,}/g, ' ');
      if (this.value !== clean) this.value = clean;
      if (removeCb) removeCb();
    });
    list.appendChild(row);
    if (addBtnId) updateAddBtn(listId, addBtnId);
    if (removeCb) removeCb();
  }

  const MAX_EXTRA = 3;

  function updateAddBtn(listId, btnId) {
    const list = document.getElementById(listId);
    const btn  = document.getElementById(btnId);
    if (!list || !btn) return;
    btn.hidden = list.querySelectorAll('.dtf-dynamic-row').length >= MAX_EXTRA;
  }

  // Size rows — number input + unit dropdown + dimension dropdown
  function makeSizeRow(removeCb) {
    const list = $('dtf-extra-sizes-list');
    if (!list) return;
    if (list.querySelectorAll('.dtf-dynamic-row--size').length >= MAX_EXTRA) return;
    const row = document.createElement('div');
    row.className = 'dtf-dynamic-row dtf-dynamic-row--size';
    row.innerHTML =
      '<input type="text" inputmode="decimal" class="dtf-input dtf-input--short dtf-size-num" placeholder="e.g. 12" autocomplete="off">' +
      '<select class="dtf-select dtf-size-unit-sel" aria-label="Unit"><option value="inches">inches</option><option value="cm">cm</option></select>' +
      '<select class="dtf-select dtf-size-dim-sel" aria-label="Dimension"><option value="Width">Width</option><option value="Height">Height</option></select>' +
      '<button type="button" class="dtf-remove-row" aria-label="Remove">&#10005;</button>';
    const numInput = row.querySelector('.dtf-size-num');
    numInput.addEventListener('input', function () {
      // Numbers and periods only; prevent double periods
      var clean = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
      if (this.value !== clean) this.value = clean;
      if (removeCb) removeCb();
    });
    row.querySelector('.dtf-size-unit-sel').addEventListener('change', function () {
      if (removeCb) removeCb();
    });
    row.querySelector('.dtf-size-dim-sel').addEventListener('change', function () {
      if (removeCb) removeCb();
    });
    row.querySelector('.dtf-remove-row').addEventListener('click', function () {
      row.remove();
      updateAddBtn('dtf-extra-sizes-list', 'dtf-add-size');
      if (removeCb) removeCb();
    });
    list.appendChild(row);
    updateAddBtn('dtf-extra-sizes-list', 'dtf-add-size');
    if (removeCb) removeCb();
  }

  function formatSizeLabel(num, unit, dim) {
    const unitLabel = unit === 'cm' ? 'cm' : 'inch';
    const dimLabel  = dim  === 'Height' ? 'tall' : 'wide';
    return num + ' ' + unitLabel + ' ' + dimLabel;
  }

  function getSizeValues() {
    const list = $('dtf-extra-sizes-list');
    if (!list) return [];
    return Array.from(list.querySelectorAll('.dtf-dynamic-row--size')).map(function (row) {
      const n = row.querySelector('.dtf-size-num');
      const u = row.querySelector('.dtf-size-unit-sel');
      const d = row.querySelector('.dtf-size-dim-sel');
      const num = n ? n.value.trim() : '';
      return num ? formatSizeLabel(num, u ? u.value : 'inches', d ? d.value : 'Width') : '';
    }).filter(Boolean);
  }

  function getListValues(listId) {
    const list = $(listId);
    if (!list) return [];
    return Array.from(list.querySelectorAll('input'))
      .map(function (i) { return i.value.trim(); })
      .filter(Boolean);
  }

  // ─── Pricing ───────────────────────────────────────────────────────────────
  function getCounts() {
    const sizeList  = $('dtf-extra-sizes-list');
    const colorList = $('dtf-extra-colors-list');
    const s = sizeList  ? Math.min(sizeList.querySelectorAll('.dtf-dynamic-row--size').length, 3) : 0;
    const c = colorList ? Math.min(colorList.querySelectorAll('.dtf-dynamic-row').length,      3) : 0;
    return { sizeCount: s, colorCount: c };
  }

  function recalcPrice() {
    const { sizeCount, colorCount } = getCounts();
    const total     = (PRICE_MAP[colorCount]  && PRICE_MAP[colorCount][sizeCount])  || 0;
    const variantId = (VARIANT_MAP[colorCount] && VARIANT_MAP[colorCount][sizeCount]) || null;
    const basePrice = (PRICE_MAP[0] && PRICE_MAP[0][0]) || 0;

    // Update the variant ID so the right price is submitted
    const idInput = document.querySelector('input[name="id"]');
    if (idInput && variantId) idInput.value = variantId;

    const lines = [];
    if (sizeCount)  lines.push({ label: 'Additional sizes ('        + sizeCount  + ')', amount: sizeCount  * 500 });
    if (colorCount) lines.push({ label: 'Additional shirt colors ('  + colorCount + ')', amount: colorCount * 500 });

    // Rebuild price-lines section (keep base line, replace the rest)
    const priceLines = $('dtf-price-lines');
    if (priceLines) {
      Array.from(priceLines.querySelectorAll('.dtf-price-line')).forEach(function (el) {
        if (el.id !== 'dtf-price-line-base') el.remove();
      });
      lines.forEach(function (l) {
        const div = document.createElement('div');
        div.className = 'dtf-price-line dtf-price-line--addon';
        div.innerHTML = '<span>' + l.label + '</span><span>' + formatMoney(l.amount) + '</span>';
        priceLines.appendChild(div);
      });
    }

    const totalEl = $('dtf-total-display');
    if (totalEl) totalEl.textContent = formatMoney(total);

    // Store breakdown in hidden property
    const breakdown = ['Base: ' + formatMoney(basePrice)]
      .concat(lines.map(function (l) { return l.label + ': ' + formatMoney(l.amount); }))
      .concat(['Total: ' + formatMoney(total)])
      .join(' | ');
    const propBreakdown = $('prop-price-breakdown');
    if (propBreakdown) propBreakdown.value = breakdown;

    return total;
  }

  // ─── Conditional visibility ────────────────────────────────────────────────
  function updateShirtColorVisibility() {
    const knockout = document.querySelector('[name="dtf-knockout"]:checked');
    const halftone = document.querySelector('[name="dtf-halftone"]:checked');
    const knockoutYes = knockout && knockout.value === 'yes';
    const halftoneYes = halftone && (halftone.value === 'yes' || halftone.value === 'not-sure');
    const section = $('dtf-shirt-color-section');
    if (knockoutYes || halftoneYes) {
      show(section);
    } else {
      hide(section);
      const colorInput = $('dtf-shirt-color');
      if (colorInput) colorInput.value = '';
      const noRadio = document.querySelector('[name="dtf-multi-color"][value="no"]');
      if (noRadio) { noRadio.checked = true; }
      hide($('dtf-extra-colors-section'));
    }
  }

  function updateMultipleColorsVisibility() {
    const checked = document.querySelector('[name="dtf-multi-color"]:checked');
    const section = $('dtf-extra-colors-section');
    if (checked && checked.value === 'yes') {
      show(section);
      if ($('dtf-extra-colors-list') && !$('dtf-extra-colors-list').children.length) {
        makeDynamicRow('dtf-extra-colors-list', 'e.g. White, Red', recalcPrice, 'dtf-add-color');
      }
    } else {
      hide(section);
      if ($('dtf-extra-colors-list')) $('dtf-extra-colors-list').innerHTML = '';
      recalcPrice();
    }
  }

  function updateMultipleSizesVisibility() {
    const checked = document.querySelector('[name="dtf-multiple-sizes"]:checked');
    const section = $('dtf-extra-sizes-section');
    if (checked && checked.value === 'yes') {
      show(section);
      if ($('dtf-extra-sizes-list') && !$('dtf-extra-sizes-list').children.length) {
        makeSizeRow(recalcPrice);
      }
    } else {
      hide(section);
      if ($('dtf-extra-sizes-list')) $('dtf-extra-sizes-list').innerHTML = '';
      recalcPrice();
    }
  }

  // ─── Thumbnail helper (for cart preview) ──────────────────────────────────
  // Always calls callback — with a base64 string on success, null on any failure.
  // Never blocks file acceptance. Handles CMYK, ICC profiles, and unusual encodings
  // by wrapping canvas operations in try/catch so a decode error is silently ignored.
  function generateThumbnail(file, callback) {
    const reader = new FileReader();
    reader.onload = function (e) {
      const img = new Image();
      img.onload = function () {
        try {
          // Draw at 2× the CSS display size (80px) for retina sharpness
          const displaySize = 80;
          const dpr = Math.min(window.devicePixelRatio || 1, 2);
          const maxPixels = displaySize * dpr;
          const scale = Math.min(maxPixels / img.width, maxPixels / img.height, 1);
          const w = Math.round(img.width * scale) || 1;
          const h = Math.round(img.height * scale) || 1;
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, w, h);
          callback(canvas.toDataURL('image/jpeg', 0.85));
        } catch (err) {
          // CMYK, embedded ICC profile, or canvas security error — skip thumbnail
          callback(null);
        }
      };
      img.onerror = function () { callback(null); };
      img.src = e.target.result;
    };
    reader.onerror = function () { callback(null); };
    // Use readAsDataURL so the browser decodes the bytes; if it can't, onerror fires
    reader.readAsDataURL(file);
  }

  // ─── File upload ───────────────────────────────────────────────────────────
  function handleFileChange(file) {
    if (!file) return;

    const placeholder    = $('dtf-upload-placeholder');
    const selected       = $('dtf-upload-selected');
    const filename       = $('dtf-upload-filename');
    const previewImg     = $('dtf-preview-img');
    const previewFallback = $('dtf-preview-fallback');

    // ── 0. Client-side file size check (200 MB max) ──
    const MAX_BYTES = 50 * 1024 * 1024;
    if (file.size > MAX_BYTES) {
      setError('dtf-file-error', 'File is too large (max 50 MB). Please compress your file and try again.');
      return;
    }

    // ── 1. Always accept the file immediately — never gate on preview success ──
    hide(placeholder);
    show(selected);
    if (filename) filename.textContent = file.name;
    setError('dtf-file-error', '');

    // Store file reference right away so validation always passes
    if (!SUPABASE_URL || !SUPABASE_KEY) {
      const propFile = $('prop-file-url');
      if (propFile) propFile.value = '[FILE] ' + file.name;
    }

    // ── 2. Attempt inline preview — degrade gracefully on any failure ──
    if (previewImg) {
      hide(previewImg);
      if (previewFallback) hide(previewFallback);

      const objectUrl = URL.createObjectURL(file);

      previewImg.onload = function () {
        show(previewImg);
        if (previewFallback) hide(previewFallback);
        // Don't revoke yet — modal preview needs the same src
        // Store for eyedropper
        eyedropperImageSrc = objectUrl;
        updateEyedropperBtnVisibility();
      };

      previewImg.onerror = function () {
        // Browser couldn't decode the file (CMYK, ICC profile, unusual encoding, etc.)
        // Show the file-icon fallback. The file is still attached and will submit fine.
        previewImg.src = '';
        hide(previewImg);
        URL.revokeObjectURL(objectUrl);
        if (previewFallback) show(previewFallback);
        // No image for eyedropper
        eyedropperImageSrc = null;
        updateEyedropperBtnVisibility();
      };

      previewImg.src = objectUrl;
    }

    // ── 3. Try generating a cart thumbnail (fire-and-forget, never blocks submit) ──
    generateThumbnail(file, function (dataUrl) {
      if (!dataUrl) return;
      const previewId = 'dtf_' + Date.now();
      try {
        localStorage.setItem(previewId, dataUrl);
        const propPreviewId = $('prop-preview-id');
        if (propPreviewId) propPreviewId.value = previewId;
      } catch (e) {
        // localStorage unavailable — ignore
      }
    });

    // ── 4. Upload to Supabase if configured ──
    if (SUPABASE_URL && SUPABASE_KEY) {
      uploadFile(file);
    }
  }

  function uploadFile(file, attempt) {
    attempt = attempt || 1;
    const progress = $('dtf-upload-progress');
    const fill     = $('dtf-progress-fill');
    const status   = $('dtf-upload-status');
    show(progress);
    if (fill) fill.style.width = '0%';
    if (status) status.textContent = 'Uploading\u2026';

    const ext           = file.name.split('.').pop();
    const uniqueName    = Date.now() + '-' + Math.random().toString(36).slice(2) + '.' + ext;
    const encodedBucket = encodeURIComponent(SUPABASE_BUCKET);
    const uploadUrl     = SUPABASE_URL + '/storage/v1/object/' + encodedBucket + '/' + uniqueName;
    const publicUrl     = SUPABASE_URL + '/storage/v1/object/public/' + encodedBucket + '/' + uniqueName;

    const submitBtn = $('dtf-submit-btn');
    if (submitBtn) submitBtn.disabled = true;

    function onFail(msg) {
      if (attempt < 2) {
        // Silent retry after short delay
        setTimeout(function () { uploadFile(file, 2); }, 1500);
      } else {
        hide(progress);
        if (submitBtn) submitBtn.disabled = false;
        setError('dtf-file-error', msg);
      }
    }

    const xhr = new XMLHttpRequest();
    xhr.open('POST', uploadUrl, true);
    xhr.setRequestHeader('Authorization', 'Bearer ' + SUPABASE_KEY);
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');

    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable && fill) {
        fill.style.width = Math.round((e.loaded / e.total) * 100) + '%';
      }
    };

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        hide(progress);
        if (submitBtn) submitBtn.disabled = false;
        const propFile = $('prop-file-url');
        if (propFile) propFile.value = publicUrl;
      } else {
        var msg = 'File upload failed. Please try again.';
        try {
          const errRes = JSON.parse(xhr.responseText);
          msg = errRes.message || errRes.error || msg;
        } catch (e) {}
        onFail(msg);
      }
    };

    xhr.onerror = function () {
      onFail('Upload error. Check your connection and try again.');
    };

    xhr.send(file);
  }

  function resetFileInput() {
    const input       = $('dtf-file-input');
    const placeholder = $('dtf-upload-placeholder');
    const selected    = $('dtf-upload-selected');
    const previewImg  = $('dtf-preview-img');
    const propFile    = $('prop-file-url');
    const propPreview = $('prop-preview-id');
    if (input) input.value = '';
    if (propFile) propFile.value = '';
    if (propPreview) propPreview.value = '';
    show(placeholder);
    hide(selected);
    if (previewImg) { previewImg.src = ''; hide(previewImg); }
    eyedropperImageSrc = null;
    updateEyedropperBtnVisibility();
    var swatch = $('dtf-color-swatch');
    if (swatch) swatch.hidden = true;
  }

  // ─── Validation ────────────────────────────────────────────────────────────
  function validate() {
    clearErrors();
    let valid = true;

    // File
    const propFile = $('prop-file-url');
    if (!propFile || !propFile.value) {
      setError('dtf-file-error', 'Please upload your artwork file.');
      valid = false;
    }

    // Size
    const sizeVal = $('dtf-size-value');
    if (!sizeVal || !sizeVal.value || parseFloat(sizeVal.value) <= 0) {
      setError('dtf-size-error', 'Please enter a valid design size.');
      valid = false;
    }

    // Shirt color (when visible)
    const shirtSection = $('dtf-shirt-color-section');
    if (shirtSection && !shirtSection.hidden) {
      const colorInput = $('dtf-shirt-color');
      if (!colorInput || !colorInput.value.trim()) {
        setError('dtf-shirt-color-error', 'Please enter the shirt color.');
        valid = false;
      }
    }

    // Extra size rows — all must be filled in
    const extraSizeList = $('dtf-extra-sizes-list');
    if (extraSizeList) {
      extraSizeList.querySelectorAll('.dtf-dynamic-row--size').forEach(function (row) {
        const num = row.querySelector('.dtf-size-num');
        if (!num || !num.value.trim()) {
          num.style.borderColor = 'red';
          num.addEventListener('input', function () { num.style.borderColor = ''; }, { once: true });
          setError('dtf-size-error', 'Please fill in all additional size fields.');
          valid = false;
        }
      });
    }

    // Extra color rows — all must be filled in
    const extraColorList = $('dtf-extra-colors-list');
    if (extraColorList) {
      extraColorList.querySelectorAll('.dtf-dynamic-row input').forEach(function (input) {
        if (!input.value.trim()) {
          input.style.borderColor = 'red';
          input.addEventListener('input', function () { input.style.borderColor = ''; }, { once: true });
          setError('dtf-shirt-color-error', 'Please fill in all additional shirt color fields.');
          valid = false;
        }
      });
    }

    return valid;
  }

  // ─── Build hidden property values before submit ────────────────────────────
  function syncProperties() {
    // Knockout
    const knockout = document.querySelector('[name="dtf-knockout"]:checked');
    const propKnockout = $('prop-knockout');
    if (propKnockout && knockout) {
      propKnockout.value = knockout.value === 'yes' ? 'Yes' : 'No';
    }

    // Halftone
    const halftone = document.querySelector('[name="dtf-halftone"]:checked');
    const propHalftone = $('prop-halftone');
    if (propHalftone && halftone) {
      const map = { 'no': 'No', 'yes': 'Yes', 'not-sure': 'Not Sure' };
      propHalftone.value = map[halftone.value] || 'No';
    }

    // Design sizes — primary + additional combined into one property
    const primarySizeNum  = $('dtf-size-value');
    const primarySizeUnit = $('dtf-size-unit');
    const primarySizeDim  = $('dtf-size-dimension');
    const allSizes = [];
    if (primarySizeNum && primarySizeNum.value.trim()) {
      allSizes.push(formatSizeLabel(
        primarySizeNum.value.trim(),
        primarySizeUnit ? primarySizeUnit.value : 'inches',
        primarySizeDim  ? primarySizeDim.value  : 'Width'
      ));
    }
    getSizeValues().forEach(function (s) { allSizes.push(s); });
    const propSizes = $('prop-design-sizes');
    if (propSizes) propSizes.value = allSizes.join(', ');

    // Shirt color — primary + additional combined into one property
    const shirtColorEl = $('dtf-shirt-color');
    const allColors = [];
    if (shirtColorEl && shirtColorEl.value.trim()) allColors.push(shirtColorEl.value.trim());
    getListValues('dtf-extra-colors-list').forEach(function (c) { allColors.push(c); });
    const propShirtColor = $('prop-shirt-color');
    if (propShirtColor) propShirtColor.value = allColors.join(', ');
  }

  // ─── Form submit ───────────────────────────────────────────────────────────
  function handleSubmit(e) {
    e.preventDefault();

    if (!validate()) {
      const firstError = document.querySelector('.dtf-error:not([hidden])');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    syncProperties();

    const btn        = $('dtf-submit-btn');
    const label      = $('dtf-submit-label');
    const loading    = $('dtf-submit-loading');
    const errorsBox  = $('dtf-submit-errors');

    if (btn) btn.disabled = true;
    hide(label);
    show(loading);
    hide(errorsBox);

    const form = $('dtf-cart-form');
    const data = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Cart error'); });
        return res.json();
      })
      .then(function () {
        // Trigger the Horizon theme's cart update — 'cart:update' is ThemeEvents.cartUpdate.
        // Passing an empty sections object causes the cart-items component to call
        // sectionRenderer.renderSection(), which fetches fresh cart HTML from Shopify.
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));

        // Re-enable submit button and reset the form
        if (btn) btn.disabled = false;
        show(label);
        hide(loading);
        resetForm();

        // Scroll back to top of page
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Open the native Shopify cart drawer — try each mechanism in order
        openCartDrawer();

        // Re-inject localStorage thumbnails into the refreshed cart DOM
        if (typeof window.dtfLoadCartThumbs === 'function') {
          // Small delay lets the theme finish replacing the cart HTML
          setTimeout(window.dtfLoadCartThumbs, 300);
        }
      })
      .catch(function (err) {
        if (btn) btn.disabled = false;
        show(label);
        hide(loading);
        if (errorsBox) {
          errorsBox.textContent = err.message || 'Something went wrong. Please try again.';
          show(errorsBox);
          errorsBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
  }

  // ─── Full form reset (called after successful cart add) ────────────────────
  function resetForm() {
    // File upload
    resetFileInput();

    // Size fields
    var sizeVal = $('dtf-size-value');
    if (sizeVal) sizeVal.value = '';
    var sizeDim = $('dtf-size-dimension');
    if (sizeDim) sizeDim.selectedIndex = 0;
    var sizeUnit = $('dtf-size-unit');
    if (sizeUnit) sizeUnit.selectedIndex = 0;

    // Reset all radio groups to their first (default) option
    ['dtf-multiple-sizes', 'dtf-knockout', 'dtf-halftone', 'dtf-multi-color'].forEach(function (name) {
      var first = document.querySelector('[name="' + name + '"]');
      if (first) first.checked = true;
    });

    // Clear dynamic lists and hide conditional sections
    ['dtf-extra-sizes-list', 'dtf-extra-colors-list'].forEach(function (id) {
      var el = $(id);
      if (el) el.innerHTML = '';
    });
    hide($('dtf-extra-sizes-section'));
    hide($('dtf-extra-colors-section'));
    hide($('dtf-shirt-color-section'));

    // Shirt color
    var shirtColor = $('dtf-shirt-color');
    if (shirtColor) shirtColor.value = '';

    // Notes
    var notes = $('dtf-notes');
    if (notes) notes.value = '';

    // Hidden properties
    ['prop-knockout', 'prop-halftone', 'prop-additional-sizes',
     'prop-additional-colors', 'prop-price-breakdown', 'prop-preview-id'].forEach(function (id) {
      var el = $(id);
      if (el) el.value = el.defaultValue || '';
    });

    // Errors
    clearErrors();
    hide($('dtf-submit-errors'));

    // Recalc price back to base
    recalcPrice();

    // Scroll back to top of form
    var wrapper = $('dtf-form-wrapper');
    if (wrapper) wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ─── Tooltips (keyboard / focus support) ───────────────────────────────────
  function initTooltips() {
    document.querySelectorAll('.dtf-tooltip').forEach(function (tip) {
      tip.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          tip.classList.toggle('dtf-tooltip--open');
        }
        if (e.key === 'Escape') {
          tip.classList.remove('dtf-tooltip--open');
        }
      });
      tip.addEventListener('blur', function () {
        tip.classList.remove('dtf-tooltip--open');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.dtf-tooltip')) {
        document.querySelectorAll('.dtf-tooltip--open').forEach(function (t) {
          t.classList.remove('dtf-tooltip--open');
        });
      }
    });
  }

  // ─── Advanced options toggle ───────────────────────────────────────────────
  function initAdvancedToggle() {
    const btn     = $('dtf-advanced-toggle');
    const content = $('dtf-advanced-content');
    const arrow   = btn && btn.querySelector('.dtf-advanced-arrow');
    if (!btn || !content) return;

    btn.addEventListener('click', function () {
      const open = content.hidden === false;
      content.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
      if (arrow) arrow.style.transform = open ? '' : 'rotate(180deg)';
    });
  }

  // ─── Eyedropper color picker ────────────────────────────────────────────────
  var eyedropperImageSrc = null; // set when a previewable file is loaded

  function rgbToHex(r, g, b) {
    return '#' + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase();
  }

  function updateEyedropperBtnVisibility() {
    var btn = $('dtf-eyedropper-btn');
    if (!btn) return;
    btn.hidden = !eyedropperImageSrc;
  }

  function initEyedropper() {
    var btn       = $('dtf-eyedropper-btn');
    var dialog    = $('dtf-eyedropper-dialog');
    var closeBtn  = $('dtf-eyedropper-dialog-close');
    var canvas    = $('dtf-eyedropper-canvas');
    var loupe     = $('dtf-eyedropper-loupe');
    var loupeColor = $('dtf-eyedropper-loupe-color');
    var loupeHex  = $('dtf-eyedropper-loupe-hex');
    if (!btn || !dialog || !canvas) return;

    var ctx = canvas.getContext('2d', { willReadFrequently: true });

    function openPicker() {
      if (!eyedropperImageSrc) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        // Scale image to fit dialog while keeping detail
        var maxW = Math.min(window.innerWidth * 0.85, 800);
        var maxH = window.innerHeight * 0.6;
        var scale = Math.min(maxW / img.width, maxH / img.height, 1);
        canvas.width  = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        if (dialog.showModal) { dialog.showModal(); } else { dialog.setAttribute('open', ''); }
      };
      img.onerror = function () {
        setError('dtf-shirt-color-error', 'Could not load design image for color picking.');
      };
      img.src = eyedropperImageSrc;
    }

    function closePicker() {
      if (loupe) loupe.hidden = true;
      if (dialog.close) { dialog.close(); } else { dialog.removeAttribute('open'); }
    }

    function getPixelColor(e) {
      var rect = canvas.getBoundingClientRect();
      var x = Math.round((e.clientX - rect.left) * (canvas.width / rect.width));
      var y = Math.round((e.clientY - rect.top) * (canvas.height / rect.height));
      x = Math.max(0, Math.min(x, canvas.width - 1));
      y = Math.max(0, Math.min(y, canvas.height - 1));
      return ctx.getImageData(x, y, 1, 1).data;
    }

    // Live loupe on hover
    canvas.addEventListener('mousemove', function (e) {
      if (!loupe || !loupeColor || !loupeHex) return;
      var px = getPixelColor(e);
      var hex = rgbToHex(px[0], px[1], px[2]);
      loupeColor.style.background = hex;
      loupeHex.textContent = hex;

      var rect = canvas.getBoundingClientRect();
      var wrap = canvas.parentElement;
      var wrapRect = wrap.getBoundingClientRect();
      loupe.style.left = (e.clientX - wrapRect.left + wrap.scrollLeft) + 'px';
      loupe.style.top  = (e.clientY - wrapRect.top + wrap.scrollTop) + 'px';
      loupe.hidden = false;
    });

    canvas.addEventListener('mouseleave', function () {
      if (loupe) loupe.hidden = true;
    });

    // Click to pick color
    canvas.addEventListener('click', function (e) {
      var px = getPixelColor(e);
      var hex = rgbToHex(px[0], px[1], px[2]);

      // Fill the shirt color input with the hex code
      var colorInput = $('dtf-shirt-color');
      if (colorInput) colorInput.value = hex;

      // Show the swatch
      var swatch = $('dtf-color-swatch');
      if (swatch) {
        swatch.style.background = hex;
        swatch.hidden = false;
      }

      setError('dtf-shirt-color-error', '');
      closePicker();
    });

    btn.addEventListener('click', openPicker);
    if (closeBtn) closeBtn.addEventListener('click', closePicker);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closePicker(); });
    dialog.addEventListener('cancel', closePicker);
  }

  // ─── Image preview modal ───────────────────────────────────────────────────
  function initPreviewModal() {
    const dialog    = $('dtf-preview-dialog');
    const dialogImg = $('dtf-preview-dialog-img');
    const closeBtn  = $('dtf-preview-dialog-close');
    const thumbImg  = $('dtf-preview-img');

    if (!dialog || !dialogImg || !thumbImg) return;

    function openModal(src) {
      dialogImg.src = src;
      if (dialog.showModal) {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeModal() {
      if (dialog.close) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    thumbImg.addEventListener('click', function () {
      if (thumbImg.src) openModal(thumbImg.src);
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    // Close on backdrop click
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeModal();
    });

    // Close on Escape (native for <dialog>, but add fallback)
    dialog.addEventListener('cancel', closeModal);
  }

  // ─── Open native Shopify cart drawer ──────────────────────────────────────
  function openCartDrawer() {
    // 1. Standard Shopify cart open event
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    // 2. Alternate event name used by some themes
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));

    // 3. Programmatically click any cart drawer toggle button found on the page
    var toggleSelectors = [
      '[data-cart-toggle]',
      '[data-drawer-toggle="cart"]',
      '[aria-controls="cart-drawer"]',
      '[aria-controls="CartDrawer"]',
      'cart-drawer-component button[aria-haspopup="dialog"]'
    ];
    for (var i = 0; i < toggleSelectors.length; i++) {
      var toggle = document.querySelector(toggleSelectors[i]);
      if (toggle) {
        toggle.click();
        break;
      }
    }
  }

  // ─── Drag-and-drop on upload area ─────────────────────────────────────────
  function initDragDrop() {
    const area  = $('dtf-upload-area');
    const input = $('dtf-file-input');
    if (!area || !input) return;

    // No click handler needed — the file input is already absolutely positioned
    // over the entire zone (opacity:0, z-index:1) and receives clicks natively.
    // Adding input.click() here would fire the picker twice, causing it to open
    // and immediately close on the first click.

    area.addEventListener('dragover', function (e) {
      e.preventDefault();
      area.classList.add('dtf-upload-area--dragover');
    });
    area.addEventListener('dragleave', function () {
      area.classList.remove('dtf-upload-area--dragover');
    });
    area.addEventListener('drop', function (e) {
      e.preventDefault();
      area.classList.remove('dtf-upload-area--dragover');
      if (e.dataTransfer.files.length > 1) {
        alert('You can only upload 1 image at a time. Please fill out a separate form for each design.');
        return;
      }
      const file = e.dataTransfer.files[0];
      if (file) {
        try {
          const dt = new DataTransfer();
          dt.items.add(file);
          input.files = dt.files;
        } catch (err) {
          // DataTransfer not supported — proceed without syncing input.files
        }
        handleFileChange(file);
      }
    });
  }

  // ─── Init ──────────────────────────────────────────────────────────────────
  function init() {
    const form = $('dtf-cart-form');
    if (!form) return;

    // File input
    const fileInput = $('dtf-file-input');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        handleFileChange(fileInput.files[0] || null);
      });
    }

    // Remove file button
    const removeBtn = $('dtf-remove-file');
    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        resetFileInput();
        setError('dtf-file-error', '');
      });
    }

    // Knockout radios
    document.querySelectorAll('[name="dtf-knockout"]').forEach(function (r) {
      r.addEventListener('change', updateShirtColorVisibility);
    });

    // Halftone radios
    document.querySelectorAll('[name="dtf-halftone"]').forEach(function (r) {
      r.addEventListener('change', updateShirtColorVisibility);
    });

    // Multiple shirt colors
    document.querySelectorAll('[name="dtf-multi-color"]').forEach(function (r) {
      r.addEventListener('change', updateMultipleColorsVisibility);
    });

    // Multiple sizes
    document.querySelectorAll('[name="dtf-multiple-sizes"]').forEach(function (r) {
      r.addEventListener('change', updateMultipleSizesVisibility);
    });

    // Add-size button
    const addSizeBtn = $('dtf-add-size');
    if (addSizeBtn) {
      addSizeBtn.addEventListener('click', function () {
        makeSizeRow(recalcPrice);
      });
    }

    // Shirt color sanitization
    const shirtColorInput = $('dtf-shirt-color');
    if (shirtColorInput) {
      shirtColorInput.addEventListener('input', function () {
        // Allow letters, spaces, and hex codes (#ABC123)
        var clean = this.value.replace(/[^a-zA-Z0-9# ]/g, '').replace(/ {2,}/g, ' ');
        if (this.value !== clean) this.value = clean;
        // Update swatch if value looks like a hex code
        var swatch = $('dtf-color-swatch');
        if (swatch) {
          var hexMatch = this.value.match(/^#([0-9A-Fa-f]{6})$/);
          if (hexMatch) {
            swatch.style.background = this.value;
            swatch.hidden = false;
          } else {
            swatch.hidden = true;
          }
        }
      });
    }

    // Add-color button
    const addColorBtn = $('dtf-add-color');
    if (addColorBtn) {
      addColorBtn.addEventListener('click', function () {
        makeDynamicRow('dtf-extra-colors-list', 'e.g. White, Red', recalcPrice, 'dtf-add-color');
      });
    }

    // Submit
    form.addEventListener('submit', handleSubmit);

    initTooltips();
    initAdvancedToggle();
    initDragDrop();
    initPreviewModal();
    initEyedropper();
    recalcPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();